// // // // // import React, { useState, useEffect } from 'react';
// // // // // import './Project.css';
// // // // // import axios from 'axios';
// // // // // import { useLocation } from 'react-router-dom';
// // // // // import DetailsCard1 from '../detailsCard/DetailsCard';

// // // // // let backendURL = process.env.REACT_APP_backend_url;

// // // // // function Projects() {
// // // // //   const [searchQuery, setSearchQuery] = useState('');
// // // // //   const [filteredProjects, setFilteredProjects] = useState([]);
// // // // //   const [loading, setLoading] = useState(false);
// // // // //   const [currentPage, setCurrentPage] = useState(1);
// // // // //   const [itemsPerPage] = useState(9); // Set the number of items per page
// // // // //   const location = useLocation();

// // // // //   useEffect(() => {
// // // // //     const query = new URLSearchParams(location.search).get('query');
// // // // //     if (query) {
// // // // //       setSearchQuery(query);
// // // // //       searchProjects(query);
// // // // //     }
// // // // //   }, [location.search]);

// // // // //   function searchProjects(query) {
// // // // //     setLoading(true);

// // // // //     fetch(`${backendURL}/searchForProject`, {
// // // // //       method: 'POST',
// // // // //       headers: {
// // // // //         'Content-Type': 'application/json',
// // // // //       },
// // // // //       body: JSON.stringify({ query }),
// // // // //     })
// // // // //       .then(response => response.json())
// // // // //       .then(data => {
// // // // //         console.log("API Response:", data);
// // // // //         setFilteredProjects(data);
// // // // //         setLoading(false);
// // // // //       })
// // // // //       .catch(error => {
// // // // //         console.error('Error:', error);
// // // // //         setLoading(false);
// // // // //       });
// // // // //   }

// // // // //   const handleSearchChange = (event) => {
// // // // //     const query = event.target.value;
// // // // //     setSearchQuery(query);
// // // // //     searchProjects(query);
// // // // //   };

// // // // //   // Pagination Logic
// // // // //   const indexOfLastProject = currentPage * itemsPerPage;
// // // // //   const indexOfFirstProject = indexOfLastProject - itemsPerPage;
// // // // //   const currentProjects = filteredProjects.slice(indexOfFirstProject, indexOfLastProject);

// // // // //   const paginate = (pageNumber) => setCurrentPage(pageNumber);

// // // // //   return (
// // // // //     <div className="projects-container">
// // // // //       <div className="container-fluid">
// // // // //         <div className="box1 p-2 text-dark">
// // // // //           <h1 className="text-center">PROJECTS</h1>
// // // // //           <p className="text-center">Find, Learn, and Inspire</p>
// // // // //         </div>
// // // // //         <hr className="hrr" />
// // // // //         <form className="form d-flex justify-content-center" role="search" onSubmit={e => e.preventDefault()}>
// // // // //           <input
// // // // //             className="form-control me-2 shadow"
// // // // //             type="search"
// // // // //             placeholder="Enter Title"
// // // // //             aria-label="Search"
// // // // //             value={searchQuery}
// // // // //             onChange={handleSearchChange}
// // // // //           />
// // // // //           <button className="btn btn-success shadow" type="submit">Search</button>
// // // // //         </form>
// // // // //         <div className="project-list mt-4">
// // // // //           {loading ? (
// // // // //             <div className="text-center">
// // // // //               <div className="spinner-border" role="status">
// // // // //                 <span className="sr-only">Loading...</span>
// // // // //               </div>
// // // // //             </div>
// // // // //           ) : currentProjects.length > 0 ? (
// // // // //             <div className="row">
// // // // //               {currentProjects.map((project, index) => (
// // // // //                 <div key={index} className="col-md-4">
// // // // //                   <DetailsCard1
// // // // //                     data={project.project}  // ✅ Pass nested data object
// // // // //                     score={project.score || 0}  // ✅ Ensure score is handled
// // // // //                   />
// // // // //                 </div>
// // // // //               ))}
// // // // //             </div>
// // // // //           ) : (
// // // // //             <p className="text-center">No projects found</p>
// // // // //           )}
// // // // //         </div>
// // // // //         <div className="pagination-controls text-center">
// // // // //           <button
// // // // //             onClick={() => paginate(currentPage - 1)}
// // // // //             disabled={currentPage === 1}
// // // // //             className="btn btn-secondary"
// // // // //           >
// // // // //             Prev
// // // // //           </button>
// // // // //           <span className="mx-2">
// // // // //             Page {currentPage} of {Math.ceil(filteredProjects.length / itemsPerPage)}
// // // // //           </span>
// // // // //           <button
// // // // //             onClick={() => paginate(currentPage + 1)}
// // // // //             disabled={currentPage === Math.ceil(filteredProjects.length / itemsPerPage)}
// // // // //             className="btn btn-secondary"
// // // // //           >
// // // // //             Next
// // // // //           </button>
// // // // //         </div>
// // // // //       </div>
// // // // //     </div>
// // // // //   );
// // // // // }

// // // // // export default Projects;

// // // // import React, { useState, useEffect } from 'react';
// // // // import './Project.css';
// // // // import axios from 'axios';
// // // // import { useLocation } from 'react-router-dom';
// // // // import DetailsCard1 from '../detailsCard/DetailsCard';

// // // // let backendURL = process.env.REACT_APP_backend_url;

// // // // function Projects() {
// // // //   const [searchQuery, setSearchQuery] = useState('');
// // // //   const [filteredProjects, setFilteredProjects] = useState([]);
// // // //   const [loading, setLoading] = useState(false);
// // // //   const [currentPage, setCurrentPage] = useState(1);
// // // //   const [itemsPerPage] = useState(9);
// // // //   const [selectedQuote, setSelectedQuote] = useState('');

// // // //   const location = useLocation();

// // // //   const quotes = [
// // // //     "Innovation is the ability to see change as an opportunity.",
// // // //     "Great things never come from comfort zones.",
// // // //     "The secret to getting ahead is getting started.",
// // // //     "Every project is an opportunity to learn and grow.",
// // // //     "Creativity is intelligence having fun.",
// // // //     "Don't wait for opportunity. Create it."
// // // //   ];

// // // //   useEffect(() => {
// // // //     const query = new URLSearchParams(location.search).get('query');
// // // //     if (query) {
// // // //       setSearchQuery(query);
// // // //       searchProjects(query);
// // // //     }
// // // //   }, [location.search]);

// // // //   function searchProjects(query) {
// // // //     setLoading(true);
// // // //     setSelectedQuote(quotes[Math.floor(Math.random() * quotes.length)]); // Random quote

// // // //     fetch(`${backendURL}/searchForProject`, {
// // // //       method: 'POST',
// // // //       headers: {
// // // //         'Content-Type': 'application/json',
// // // //       },
// // // //       body: JSON.stringify({ query }),
// // // //     })
// // // //       .then(response => response.json())
// // // //       .then(data => {
// // // //         console.log(data)
// // // //         setTimeout(() => {
// // // //           setFilteredProjects(data);
// // // //           setLoading(false);
// // // //         }, 3000); // 3 seconds delay
// // // //       })
// // // //       .catch(error => {
// // // //         console.error('Error:', error);
// // // //         setLoading(false);
// // // //       });
// // // //   }

// // // //   const handleSearchChange = (event) => {
// // // //     const query = event.target.value;
// // // //     setSearchQuery(query);
// // // //     searchProjects(query);
// // // //   };

// // // //   // Pagination Logic
// // // //   const indexOfLastProject = currentPage * itemsPerPage;
// // // //   const indexOfFirstProject = indexOfLastProject - itemsPerPage;
// // // //   const currentProjects = filteredProjects.slice(indexOfFirstProject, indexOfLastProject);

// // // //   const paginate = (pageNumber) => setCurrentPage(pageNumber);

// // // //   return (
// // // //     <div className="projects-container">
// // // //       <div className="container-fluid">
// // // //         <div className="box1 p-2 text-dark">
// // // //           <h1 className="text-center">PROJECTS</h1>
// // // //           <p className="text-center">Find, Learn, and Inspire</p>
// // // //         </div>
// // // //         <hr className="hrr" />
// // // //         <form className="form d-flex justify-content-center" role="search" onSubmit={e => e.preventDefault()}>
// // // //           <input
// // // //             className="form-control me-2 shadow"
// // // //             type="search"
// // // //             placeholder="Enter Title"
// // // //             aria-label="Search"
// // // //             value={searchQuery}
// // // //             onChange={handleSearchChange}
// // // //           />
// // // //           <button className="btn btn-success shadow" type="submit">Search</button>
// // // //         </form>

// // // //         <div className="project-list mt-4">
// // // //           {loading ? (
// // // //             <div className="text-center my-5">
// // // //               <div className="horizontal-loader mx-auto mb-3"></div>
// // // //               <p className="quote-text fst-italic text-muted">{selectedQuote}</p>
// // // //               <p className="text-secondary">Loading results, please wait...</p>
// // // //             </div>
// // // //           ) : currentProjects.length > 0 ? (
// // // //             <div className="row">
// // // //               {currentProjects.map((project, index) => (
// // // //                 <div key={index} className="col-md-4">
// // // //                   <DetailsCard1
// // // //                     data={project.project}
// // // //                     score={project.score || 0}
// // // //                   />
// // // //                 </div>
// // // //               ))}
// // // //             </div>
// // // //           ) : (
// // // //             <p className="text-center">No projects found</p>
// // // //           )}
// // // //         </div>

// // // //         <div className="pagination-controls text-center my-4">
// // // //           <button
// // // //             onClick={() => paginate(currentPage - 1)}
// // // //             disabled={currentPage === 1}
// // // //             className="btn btn-secondary me-2"
// // // //           >
// // // //             Prev
// // // //           </button>
// // // //           <span className="mx-2">
// // // //             Page {currentPage} of {Math.ceil(filteredProjects.length / itemsPerPage)}
// // // //           </span>
// // // //           <button
// // // //             onClick={() => paginate(currentPage + 1)}
// // // //             disabled={currentPage === Math.ceil(filteredProjects.length / itemsPerPage)}
// // // //             className="btn btn-secondary ms-2"
// // // //           >
// // // //             Next
// // // //           </button>
// // // //         </div>
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // }

// // // // export default Projects;
// // // // import React, { useState, useEffect, useCallback } from 'react';
// // // // import './Project.css';
// // // // import axios from 'axios';
// // // // import { useLocation } from 'react-router-dom';
// // // // import DetailsCard1 from '../detailsCard/DetailsCard';

// // // // let backendURL = process.env.REACT_APP_backend_url;
// // // // let apiKey = process.env.REACT_APP_API_KEY;

// // // // function Projects() {
// // // //   const [searchQuery, setSearchQuery] = useState('');
// // // //   const [filteredProjects, setFilteredProjects] = useState([]);
// // // //   const [loading, setLoading] = useState(false);
// // // //   const [currentPage, setCurrentPage] = useState(1);
// // // //   const [itemsPerPage] = useState(9);
// // // //   const [selectedQuote, setSelectedQuote] = useState('');
// // // //   const [debounceTimer, setDebounceTimer] = useState(null);
// // // //   const location = useLocation();

// // // //   const quotes = [
// // // //     "Innovation is the ability to see change as an opportunity.",
// // // //     "Great things never come from comfort zones.",
// // // //     "The secret to getting ahead is getting started.",
// // // //     "Every project is an opportunity to learn and grow.",
// // // //     "Creativity is intelligence having fun.",
// // // //     "Don't wait for opportunity. Create it."
// // // //   ];

// // // //   useEffect(() => {
// // // //     const query = new URLSearchParams(location.search).get('query');
// // // //     if (query) {
// // // //       setSearchQuery(query);
// // // //       searchProjects(query);
// // // //     }
// // // //   }, [location.search]);

// // // //   // Function to search for projects
// // // //   function searchProjects(query) {
// // // //     setLoading(true);
// // // //     setSelectedQuote(quotes[Math.floor(Math.random() * quotes.length)]); // Random quote

// // // //     axios.post(`${backendURL}/searchForProject`, {
// // // //       query: query,
// // // //       apiKey: apiKey  // Pass the API key if required for backend
// // // //     })
// // // //       .then((response) => {
// // // //         console.log("API Response:", response.data);
// // // //         setTimeout(() => {
// // // //           setFilteredProjects(response.data);
// // // //           setLoading(false);
// // // //         }, 3000); // 3 seconds delay to show loading state
// // // //       })
// // // //       .catch((error) => {
// // // //         console.error('Error:', error);
// // // //         setLoading(false);
// // // //       });
// // // //   }

// // // //   // Debounced search and quote change logic
// // // //   const handleSearchChange = useCallback((event) => {
// // // //     const query = event.target.value;
// // // //     setSearchQuery(query);

// // // //     if (debounceTimer) {
// // // //       clearTimeout(debounceTimer);
// // // //     }

// // // //     setDebounceTimer(
// // // //       setTimeout(() => {
// // // //         searchProjects(query);
// // // //         // Change quote after a delay of 3 seconds after typing stops
// // // //         setSelectedQuote(quotes[Math.floor(Math.random() * quotes.length)]);
// // // //       }, 3000) // 3-second debounce delay
// // // //     );
// // // //   }, [debounceTimer]);

// // // //   // Pagination Logic
// // // //   const indexOfLastProject = currentPage * itemsPerPage;
// // // //   const indexOfFirstProject = indexOfLastProject - itemsPerPage;
// // // //   const currentProjects = filteredProjects.slice(indexOfFirstProject, indexOfLastProject);

// // // //   const paginate = (pageNumber) => setCurrentPage(pageNumber);

// // // //   // Check if there is more than one page
// // // //   const totalPages = Math.ceil(filteredProjects.length / itemsPerPage);
// // // //   const showPagination = totalPages > 1; // Show pagination only if there are multiple pages

// // // //   return (
// // // //     <div className="projects-container">
// // // //       <div className="container-fluid">
// // // //         <div className="box1 p-2 text-dark">
// // // //           <h1 className="text-center">PROJECTS</h1>
// // // //           <p className="text-center">Find, Learn, and Inspire</p>
// // // //         </div>
// // // //         <hr className="hrr" />
// // // //         <form className="form d-flex justify-content-center" role="search" onSubmit={e => e.preventDefault()}>
// // // //           <input
// // // //             className="form-control me-2 shadow"
// // // //             type="search"
// // // //             placeholder="Enter Title"
// // // //             aria-label="Search"
// // // //             value={searchQuery}
// // // //             onChange={handleSearchChange}
// // // //           />
// // // //           <button className="btn btn-success shadow" type="submit">Search</button>
// // // //         </form>

// // // //         <div className="project-list mt-4">
// // // //           {loading ? (
// // // //             <div className="text-center my-5">
// // // //               <div className="horizontal-loader mx-auto mb-3"></div>
// // // //               <p className="quote-text fst-italic text-muted">{selectedQuote}</p>
// // // //               <p className="text-secondary">Loading results, please wait...</p>
// // // //             </div>
// // // //           ) : currentProjects.length > 0 ? (
// // // //             <div className="row">
// // // //               {currentProjects.map((project, index) => (
// // // //                 <div key={index} className="col-md-4">
// // // //                   <DetailsCard1
// // // //                     data={project.project}
// // // //                     score={project.score || 0}
// // // //                   />
// // // //                 </div>
// // // //               ))}
// // // //             </div>
// // // //           ) : (
// // // //             <p className="text-center">No projects found</p>
// // // //           )}
// // // //         </div>

// // // //         {showPagination && (
// // // //           <div className="pagination-controls text-center my-4">
// // // //             <button
// // // //               onClick={() => paginate(currentPage - 1)}
// // // //               disabled={currentPage === 1}
// // // //               className="btn btn-secondary me-2"
// // // //             >
// // // //               Prev
// // // //             </button>
// // // //             <span className="mx-2">
// // // //               Page {currentPage} of {totalPages}
// // // //             </span>
// // // //             <button
// // // //               onClick={() => paginate(currentPage + 1)}
// // // //               disabled={currentPage === totalPages}
// // // //               className="btn btn-secondary ms-2"
// // // //             >
// // // //               Next
// // // //             </button>
// // // //           </div>
// // // //         )}
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // }

// // // // export default Projects;










// // // import React, { useState, useEffect, useCallback } from 'react';
// // // import './Project.css';
// // // import axios from 'axios';
// // // import { useLocation } from 'react-router-dom';
// // // import DetailsCard from './DetailsCard';

// // // // Environment variables should be accessed safely
// // // const backendURL = process.env.REACT_APP_backend_url || '';

// // // function Projects() {
// // //   const [searchQuery, setSearchQuery] = useState('');
// // //   const [filteredProjects, setFilteredProjects] = useState([]);
// // //   const [loading, setLoading] = useState(false);
// // //   const [currentPage, setCurrentPage] = useState(1);
// // //   const [itemsPerPage] = useState(9);
// // //   const [selectedQuote, setSelectedQuote] = useState('');
// // //   const location = useLocation();

// // //   const quotes = [
// // //     "Innovation is the ability to see change as an opportunity.",
// // //     "Great things never come from comfort zones.",
// // //     "The secret to getting ahead is getting started.",
// // //     "Every project is an opportunity to learn and grow.",
// // //     "Creativity is intelligence having fun.",
// // //     "Don't wait for opportunity. Create it."
// // //   ];

// // //   // Initialize with URL query params if present
// // //   useEffect(() => {
// // //     const query = new URLSearchParams(location.search).get('query');
// // //     if (query) {
// // //       setSearchQuery(query);
// // //       searchProjects(query);
// // //     } else {
// // //       // Optionally fetch initial projects if no query
// // //       setSelectedQuote(getRandomQuote());
// // //     }
// // //   }, [location.search]);

// // //   // Get random quote
// // //   const getRandomQuote = () => quotes[Math.floor(Math.random() * quotes.length)];

// // //   // Function to search for projects
// // //   const searchProjects = useCallback((query) => {
// // //     setLoading(true);
// // //     setSelectedQuote(getRandomQuote());

// // //     axios.post(`${backendURL}/searchForProject`, { query })
// // //       .then((response) => {
// // //         console.log("API Response:", response.data);
// // //         setFilteredProjects(response.data);
// // //         setLoading(false);
// // //       })
// // //       .catch((error) => {
// // //         console.error('Error searching projects:', error);
// // //         setLoading(false);
// // //         // Add error state handling here if needed
// // //       });
// // //   }, []);

// // //   // Debounced search using useCallback and useEffect
// // //   useEffect(() => {
// // //     if (!searchQuery) return;
    
// // //     const timer = setTimeout(() => {
// // //       searchProjects(searchQuery);
// // //     }, 800); // Reduced debounce time for better UX
    
// // //     return () => clearTimeout(timer);
// // //   }, [searchQuery, searchProjects]);

// // //   const handleSearchChange = (event) => {
// // //     setSearchQuery(event.target.value);
// // //   };

// // //   const handleSearchSubmit = (e) => {
// // //     e.preventDefault();
// // //     if (searchQuery.trim()) {
// // //       searchProjects(searchQuery);
// // //     }
// // //   };

// // //   // Pagination Logic
// // //   const indexOfLastProject = currentPage * itemsPerPage;
// // //   const indexOfFirstProject = indexOfLastProject - itemsPerPage;
// // //   const currentProjects = filteredProjects.slice(indexOfFirstProject, indexOfLastProject);
// // //   const totalPages = Math.ceil(filteredProjects.length / itemsPerPage);
// // //   const showPagination = totalPages > 1;

// // //   const paginate = (pageNumber) => setCurrentPage(pageNumber);

// // //   return (
// // //     <div className="projects-container">
// // //       <div className="container-fluid">
// // //         <div className="box1 p-2 text-dark">
// // //           <h1 className="text-center">PROJECTS</h1>
// // //           <p className="text-center">Find, Learn, and Inspire</p>
// // //         </div>
// // //         <hr className="hrr" />
        
// // //         <form className="form d-flex justify-content-center" role="search" onSubmit={handleSearchSubmit}>
// // //           <input
// // //             className="form-control me-2 shadow"
// // //             type="search"
// // //             placeholder="Enter Title"
// // //             aria-label="Search"
// // //             value={searchQuery}
// // //             onChange={handleSearchChange}
// // //           />
// // //           <button className="btn btn-success shadow" type="submit">Search</button>
// // //         </form>

// // //         <div className="project-list mt-4">
// // //           {loading ? (
// // //             <div className="text-center my-5">
// // //               <div className="horizontal-loader mx-auto mb-3"></div>
// // //               <p className="quote-text fst-italic text-muted">{selectedQuote}</p>
// // //               <p className="text-secondary">Loading results, please wait...</p>
// // //             </div>
// // //           ) : currentProjects.length > 0 ? (
// // //             <div className="row">
// // //               {currentProjects.map((project, index) => (
// // //                 <div key={project.project?.ProjectId || index} className="col-md-4 mb-4">
// // //                   <DetailsCard
// // //                     data={project.project}
// // //                     score={project.score || 0}
// // //                   />
// // //                 </div>
// // //               ))}
// // //             </div>
// // //           ) : (
// // //             <p className="text-center">No projects found. Try a different search term.</p>
// // //           )}
// // //         </div>

// // //         {showPagination && (
// // //           <nav aria-label="Project pagination">
// // //             <div className="pagination-controls text-center my-4">
// // //               <button
// // //                 onClick={() => paginate(currentPage - 1)}
// // //                 disabled={currentPage === 1}
// // //                 className="btn btn-secondary me-2"
// // //                 aria-label="Previous page"
// // //               >
// // //                 Prev
// // //               </button>
// // //               <span className="mx-2">
// // //                 Page {currentPage} of {totalPages}
// // //               </span>
// // //               <button
// // //                 onClick={() => paginate(currentPage + 1)}
// // //                 disabled={currentPage === totalPages}
// // //                 className="btn btn-secondary ms-2"
// // //                 aria-label="Next page"
// // //               >
// // //                 Next
// // //               </button>
// // //             </div>
// // //           </nav>
// // //         )}
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // // export default Projects;

// // import React, { useState, useEffect, useCallback, useRef } from 'react';
// // import './Project.css';
// // import axios from 'axios';
// // import { useLocation, useNavigate } from 'react-router-dom';
// // import DetailsCard from './DetailsCard';

// // const backendURL = process.env.REACT_APP_backend_url || '';

// // function Projects() {
// //   const [searchQuery, setSearchQuery] = useState('');
// //   const [filteredProjects, setFilteredProjects] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [currentPage, setCurrentPage] = useState(1);
// //   const [itemsPerPage] = useState(9);
// //   const [selectedQuote, setSelectedQuote] = useState('');
// //   const [error, setError] = useState(null);
// //   const [showDebounceMessage, setShowDebounceMessage] = useState(false);
// //   const location = useLocation();
// //   const navigate = useNavigate();
// //   const debounceTimer = useRef(null);

// //   const quotes = [
// //     "Innovation is the ability to see change as an opportunity.",
// //     "Great things never come from comfort zones.",
// //     "The secret to getting ahead is getting started.",
// //     "Every project is an opportunity to learn and grow.",
// //     "Creativity is intelligence having fun.",
// //     "Don't wait for opportunity. Create it.",
// //     "The best way to predict the future is to create it.",
// //     "Patience is key when searching for great projects."
// //   ];

// //   // Initialize with URL query params if present
// //   useEffect(() => {
// //     const query = new URLSearchParams(location.search).get('query') || '';
// //     setSearchQuery(query);
// //     if (query.trim()) {
// //       executeSearch(query);
// //     } else {
// //       setFilteredProjects([]);
// //       setSelectedQuote(getRandomQuote());
// //     }
// //   }, [location.search]);

// //   const getRandomQuote = () => quotes[Math.floor(Math.random() * quotes.length)];

// //   const executeSearch = useCallback(async (query) => {
// //     if (!query.trim()) {
// //       setFilteredProjects([]);
// //       setSelectedQuote(getRandomQuote());
// //       navigate('/projects');
// //       return;
// //     }

// //     setLoading(true);
// //     setError(null);
// //     setCurrentPage(1);
// //     setShowDebounceMessage(false);

// //     try {
// //       const response = await axios.post(`${backendURL}/searchForProject`, { query });
// //       setFilteredProjects(response.data || []);
// //       navigate(`/projects?query=${encodeURIComponent(query)}`, { replace: true });
// //     } catch (err) {
// //       console.error('Error searching projects:', err);
// //       setError('Failed to fetch projects. Please try again later.');
// //       setFilteredProjects([]);
// //     } finally {
// //       setLoading(false);
// //     }
// //   }, [navigate]);

// //   // Handle search input changes with proper debouncing
// //   const handleSearchChange = (event) => {
// //     const query = event.target.value;
// //     setSearchQuery(query);

// //     // Clear previous timer if it exists
// //     if (debounceTimer.current) {
// //       clearTimeout(debounceTimer.current);
// //     }

// //     if (!query.trim()) {
// //       setFilteredProjects([]);
// //       navigate('/projects');
// //       setShowDebounceMessage(false);
// //       return;
// //     }

// //     // Show debounce message immediately
// //     setShowDebounceMessage(true);
// //     setSelectedQuote(getRandomQuote());

// //     // Set new timer
// //     debounceTimer.current = setTimeout(() => {
// //       executeSearch(query);
// //     }, 3000); // 3-second debounce
// //   };

// //   const handleSearchSubmit = (e) => {
// //     e.preventDefault();
// //     // Cancel any pending debounce
// //     if (debounceTimer.current) {
// //       clearTimeout(debounceTimer.current);
// //       debounceTimer.current = null;
// //     }
// //     executeSearch(searchQuery);
// //   };

// //   const handleClearSearch = () => {
// //     setSearchQuery('');
// //     setFilteredProjects([]);
// //     navigate('/projects');
// //     setShowDebounceMessage(false);
// //     if (debounceTimer.current) {
// //       clearTimeout(debounceTimer.current);
// //       debounceTimer.current = null;
// //     }
// //   };

// //   // Clean up timer on unmount
// //   useEffect(() => {
// //     return () => {
// //       if (debounceTimer.current) {
// //         clearTimeout(debounceTimer.current);
// //       }
// //     };
// //   }, []);

// //   // Pagination Logic
// //   const indexOfLastProject = currentPage * itemsPerPage;
// //   const indexOfFirstProject = indexOfLastProject - itemsPerPage;
// //   const currentProjects = filteredProjects.slice(indexOfFirstProject, indexOfLastProject);
// //   const totalPages = Math.ceil(filteredProjects.length / itemsPerPage);
// //   const showPagination = totalPages > 1;

// //   const paginate = (pageNumber) => setCurrentPage(pageNumber);

// //   return (
// //     <div className="projects-container">
// //       <div className="container-fluid">
// //         <div className="box1 p-2 text-dark">
// //           <h1 className="text-center">PROJECTS</h1>
// //           <p className="text-center">Find, Learn, and Inspire</p>
// //         </div>
// //         <hr className="hrr" />
        
// //         <form className="form d-flex justify-content-center" role="search" onSubmit={handleSearchSubmit}>
// //           <input
// //             className="form-control me-2 shadow"
// //             type="search"
// //             placeholder="Enter Title"
// //             aria-label="Search"
// //             value={searchQuery}
// //             onChange={handleSearchChange}
// //           />
// //           <button className="btn btn-success shadow" type="submit">Search</button>
// //           {searchQuery && (
// //             <button 
// //               className="btn btn-outline-secondary shadow ms-2" 
// //               type="button"
// //               onClick={handleClearSearch}
// //             >
// //               Clear
// //             </button>
// //           )}
// //         </form>

// //         {/* Debounce Message */}
// //         {showDebounceMessage && !loading && (
// //           <div className="text-center my-4">
// //             <div className="spinner-border text-primary mb-2" role="status">
// //               <span className="visually-hidden">Loading...</span>
// //             </div>
// //             <p className="quote-text fst-italic text-muted">"{selectedQuote}"</p>
// //             <p className="text-secondary">Waiting for you to finish typing...</p>
// //           </div>
// //         )}

// //         {error && (
// //           <div className="alert alert-danger mt-3 text-center">
// //             {error}
// //           </div>
// //         )}

// //         <div className="project-list mt-4">
// //           {loading ? (
// //             <div className="text-center my-5">
// //               <div className="horizontal-loader mx-auto mb-3"></div>
// //               <p className="quote-text fst-italic text-muted">"{selectedQuote}"</p>
// //               <p className="text-secondary">Loading results, please wait...</p>
// //             </div>
// //           ) : currentProjects.length > 0 ? (
// //             <>
// //               <div className="row">
// //                 {currentProjects.map((project, index) => (
// //                   <div key={project.project?.ProjectId || index} className="col-md-4 mb-4">
// //                     <DetailsCard
// //                       data={project.project}
// //                       score={project.score || 0}
// //                     />
// //                   </div>
// //                 ))}
// //               </div>
// //               {showPagination && (
// //                 <nav aria-label="Project pagination">
// //                   <div className="pagination-controls text-center my-4">
// //                     <button
// //                       onClick={() => paginate(currentPage - 1)}
// //                       disabled={currentPage === 1}
// //                       className="btn btn-secondary me-2"
// //                       aria-label="Previous page"
// //                     >
// //                       Prev
// //                     </button>
// //                     <span className="mx-2">
// //                       Page {currentPage} of {totalPages}
// //                     </span>
// //                     <button
// //                       onClick={() => paginate(currentPage + 1)}
// //                       disabled={currentPage === totalPages}
// //                       className="btn btn-secondary ms-2"
// //                       aria-label="Next page"
// //                     >
// //                       Next
// //                     </button>
// //                   </div>
// //                 </nav>
// //               )}
// //             </>
// //           ) : (
// //             !loading && !showDebounceMessage && searchQuery && (
// //               <div className="text-center my-5">
// //                 <p className="text-muted">No projects found matching "{searchQuery}"</p>
// //                 <button 
// //                   className="btn btn-link"
// //                   onClick={handleClearSearch}
// //                 >
// //                   Clear search
// //                 </button>
// //               </div>
// //             )
// //           )}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // export default Projects;

// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import './Project.css';
// import axios from 'axios';
// import { useLocation, useNavigate } from 'react-router-dom';
// import DetailsCard from './DetailsCard';

// const backendURL = process.env.REACT_APP_backend_url || '';

// function Projects() {
//   const [searchQuery, setSearchQuery] = useState('');
//   const [filteredProjects, setFilteredProjects] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(9);
//   const [selectedQuote, setSelectedQuote] = useState('');
//   const [error, setError] = useState(null);
//   const [showDebounceMessage, setShowDebounceMessage] = useState(false);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const debounceTimer = useRef(null);

//   const quotes = [
//     "Innovation is the ability to see change as an opportunity.",
//     "Great things never come from comfort zones.",
//     "The secret to getting ahead is getting started.",
//     "Every project is an opportunity to learn and grow.",
//     "Creativity is intelligence having fun.",
//     "Don't wait for opportunity. Create it.",
//     "The best way to predict the future is to create it.",
//     "Patience is key when searching for great projects."
//   ];

//   useEffect(() => {
//     const query = new URLSearchParams(location.search).get('query') || '';
//     setSearchQuery(query);
//     if (query.trim()) {
//       executeSearch(query);
//     } else {
//       setFilteredProjects([]);
//       setSelectedQuote(getRandomQuote());
//     }
//   }, [location.search]);

//   const getRandomQuote = () => quotes[Math.floor(Math.random() * quotes.length)];

//   const executeSearch = useCallback(async (query) => {
//     if (!query.trim()) {
//       setFilteredProjects([]);
//       setSelectedQuote(getRandomQuote());
//       navigate('/projects');
//       return;
//     }

//     setLoading(true);
//     setError(null);
//     setCurrentPage(1);
//     setShowDebounceMessage(false);

//     try {
//       const response = await axios.post(`${backendURL}/searchForProject`, { query });
//       setFilteredProjects(response.data || []);
//       navigate(`/projects?query=${encodeURIComponent(query)}`, { replace: true });
//     } catch (err) {
//       console.error('Error searching projects:', err);
//       setError('Failed to fetch projects. Please try again later.');
//       setFilteredProjects([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [navigate]);

//   const handleSearchChange = (event) => {
//     const query = event.target.value;
//     setSearchQuery(query);

//     if (debounceTimer.current) {
//       clearTimeout(debounceTimer.current);
//     }

//     if (!query.trim()) {
//       setFilteredProjects([]);
//       navigate('/projects');
//       setShowDebounceMessage(false);
//       return;
//     }

//     setShowDebounceMessage(true);
//     setSelectedQuote(getRandomQuote());

//     debounceTimer.current = setTimeout(() => {
//       executeSearch(query);
//     }, 3000);
//   };

//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     if (debounceTimer.current) {
//       clearTimeout(debounceTimer.current);
//       debounceTimer.current = null;
//     }
//     executeSearch(searchQuery);
//   };

//   const handleClearSearch = () => {
//     setSearchQuery('');
//     setFilteredProjects([]);
//     navigate('/projects');
//     setShowDebounceMessage(false);
//     if (debounceTimer.current) {
//       clearTimeout(debounceTimer.current);
//       debounceTimer.current = null;
//     }
//   };

//   useEffect(() => {
//     return () => {
//       if (debounceTimer.current) {
//         clearTimeout(debounceTimer.current);
//       }
//     };
//   }, []);

//   const indexOfLastProject = currentPage * itemsPerPage;
//   const indexOfFirstProject = indexOfLastProject - itemsPerPage;
//   const currentProjects = filteredProjects.slice(indexOfFirstProject, indexOfLastProject);
//   const totalPages = Math.ceil(filteredProjects.length / itemsPerPage);
//   const showPagination = totalPages > 1;

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   return (
//     <div className="projects-container">
//       <div className="container-fluid">
//         <div className="box1 p-2 text-dark">
//           <h1 className="text-center">PROJECTS</h1>
//           <p className="text-center">Find, Learn, and Inspire</p>
//         </div>
//         <hr className="hrr" />

//         <form className="form d-flex justify-content-center" role="search" onSubmit={handleSearchSubmit}>
//           <input
//             className="form-control me-2 shadow"
//             type="search"
//             placeholder="Enter Title"
//             aria-label="Search"
//             value={searchQuery}
//             onChange={handleSearchChange}
//           />
//           <button className="btn btn-success shadow" type="submit">Search</button>
//           {searchQuery && (
//             <button 
//               className="btn btn-outline-secondary shadow ms-2" 
//               type="button"
//               onClick={handleClearSearch}
//             >
//               Clear
//             </button>
//           )}
//         </form>

//         {showDebounceMessage && !loading && (
//           <div className="text-center my-4">
//             <div className="animal-loader mx-auto mb-3" role="status"></div>
//             <p className="quote-text fst-italic text-muted">"{selectedQuote}"</p>
//             <p className="text-secondary">Waiting for you to finish typing...</p>
//           </div>
//         )}

//         {error && (
//           <div className="alert alert-danger mt-3 text-center">
//             {error}
//           </div>
//         )}

//         <div className="project-list mt-4">
//           {loading ? (
//             <div className="text-center my-5">
//               <div className="animal-loader mx-auto mb-3" role="status"></div>
//               <p className="quote-text fst-italic text-muted">"{selectedQuote}"</p>
//               <p className="text-secondary">Loading results, watch them run...</p>
//             </div>
//           ) : currentProjects.length > 0 ? (
//             <>
//               <div className="row">
//                 {currentProjects.map((project, index) => (
//                   <div 
//                     key={project.project?.ProjectId || index} 
//                     className="col-md-4 mb-4 project-appear"
//                     style={{ animationDelay: `${index * 0.1}s` }}
//                   >
//                     <DetailsCard
//                       data={project.project}
//                       score={project.score || 0}
//                     />
//                   </div>
//                 ))}
//               </div>
//               {showPagination && (
//                 <nav aria-label="Project pagination">
//                   <div className="pagination-controls text-center my-4">
//                     <button
//                       onClick={() => paginate(currentPage - 1)}
//                       disabled={currentPage === 1}
//                       className="btn btn-secondary me-2"
//                       aria-label="Previous page"
//                     >
//                       Prev
//                     </button>
//                     <span className="mx-2">
//                       Page {currentPage} of {totalPages}
//                     </span>
//                     <button
//                       onClick={() => paginate(currentPage + 1)}
//                       disabled={currentPage === totalPages}
//                       className="btn btn-secondary ms-2"
//                       aria-label="Next page"
//                     >
//                       Next
//                     </button>
//                   </div>
//                 </nav>
//               )}
//             </>
//           ) : (
//             !loading && !showDebounceMessage && searchQuery && (
//               <div className="text-center my-5">
//                 <p className="text-muted">No projects found matching "{searchQuery}"</p>
//                 <button 
//                   className="btn btn-link"
//                   onClick={handleClearSearch}
//                 >
//                   Clear search
//                 </button>
//               </div>
//             )
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Projects;


import React, { useState, useEffect, useCallback, useRef } from 'react';
import './Project.css';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import DetailsCard from './DetailsCard';

const backendURL = process.env.REACT_APP_backend_url || '';

function Projects() {
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(9);
  const [selectedQuote, setSelectedQuote] = useState('');
  const [error, setError] = useState(null);
  const [showDebounceMessage, setShowDebounceMessage] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const debounceTimer = useRef(null);

  const quotes = [
    "Innovation is the ability to see change as an opportunity.",
    "Great things never come from comfort zones.",
    "The secret to getting ahead is to get started.",
    "Every project is an opportunity to learn and grow.",
    "Creativity is intelligence having fun.",
    "Don't wait for opportunity. Create it.",
    "The best way to predict the future is to create it.",
    "Patience is key when searching for great projects."
  ];

  useEffect(() => {
    const query = new URLSearchParams(location.search).get('query') || '';
    setSearchQuery(query);
    if (query.trim()) {
      executeSearch(query);
    } else {
      setFilteredProjects([]);
      setSelectedQuote(getRandomQuote());
    }
  }, [location.search]);

  const getRandomQuote = () => quotes[Math.floor(Math.random() * quotes.length)];

  const executeSearch = useCallback(async (query) => {
    if (!query.trim()) {
      setFilteredProjects([]);
      setSelectedQuote(getRandomQuote());
      navigate('/projects');
      return;
    }

    setLoading(true);
    setError(null);
    setCurrentPage(1);
    setShowDebounceMessage(false);

    try {
      const response = await axios.post(`${backendURL}/searchForProject`, { query });
      setFilteredProjects(response.data || []);
      navigate(`/projects?query=${encodeURIComponent(query)}`, { replace: true });
    } catch (err) {
      console.error('Error searching projects:', err);
      setError('Failed to fetch projects. Please try again later.');
      setFilteredProjects([]);
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    if (!query.trim()) {
      setFilteredProjects([]);
      navigate('/projects');
      setShowDebounceMessage(false);
      return;
    }

    setShowDebounceMessage(true);
    setSelectedQuote(getRandomQuote());

    debounceTimer.current = setTimeout(() => {
      executeSearch(query);
    }, 3000);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
      debounceTimer.current = null;
    }
    executeSearch(searchQuery);
  };

  const handleClearSearch = () => {
    setSearchQuery('');
    setFilteredProjects([]);
    navigate('/projects');
    setShowDebounceMessage(false);
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
      debounceTimer.current = null;
    }
  };

  useEffect(() => {
    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, []);

  const indexOfLastProject = currentPage * itemsPerPage;
  const indexOfFirstProject = indexOfLastProject - itemsPerPage;
  const currentProjects = filteredProjects.slice(indexOfFirstProject, indexOfLastProject);
  const totalPages = Math.ceil(filteredProjects.length / itemsPerPage);
  const showPagination = totalPages > 1;

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="projects-container">
      <div className="container-fluid">
        <div className="box1 p-2 text-dark">
          <h1 className="text-center">PROJECTS</h1>
          <p className="text-center">Find, Learn, and Inspire</p>
        </div>
        <hr className="hrr" />

        <form className="form d-flex justify-content-center" role="search" onSubmit={handleSearchSubmit}>
          <input
            className="form-control me-2 shadow"
            type="search"
            placeholder="Enter Title"
            aria-label="Search"
            value={searchQuery}
            onChange={handleSearchChange}
          />
          <button className="btn btn-success shadow" type="submit">Search</button>
          {searchQuery && (
            <button 
              className="btn btn-outline-secondary shadow ms-2" 
              type="button"
              onClick={handleClearSearch}
            >
              Clear
            </button>
          )}
        </form>

        {showDebounceMessage && !loading && (
          <div className="text-center my-4">
            <div className="animal-loader mx-auto mb-3" role="status"></div>
            <p className="quote-text fst-italic text-muted">"{selectedQuote}"</p>
            <p className="text-secondary">Waiting for you to finish typing...</p>
          </div>
        )}

        {error && (
          <div className="alert alert-danger mt-3 text-center">
            {error}
          </div>
        )}

        <div className="project-list mt-4">
          {loading ? (
            <div className="loader-wrapper">
              <div className="animal-loader" role="status"></div>
              <p className="quote-text fst-italic text-muted">"{selectedQuote}"</p>
              <p className="text-secondary">Loading results, watch them run...</p>
            </div>
          )  : currentProjects.length > 0 ? (
            <>
              {currentProjects.length === 1 ? (
                <div className="d-flex justify-content-center square-card">
                  <DetailsCard
                    data={currentProjects[0].project}
                    score={currentProjects[0].score || 0}
                  />
                </div>
              ) : (
                <div className="row">
                  {currentProjects.map((project, index) => (
                    <div 
                      key={project.project?.ProjectId || index} 
                      className="col-md-4 mb-4 project-appear"
                      style={{ animationDelay: `${index * 0.1}s` }}
                    >
                      <DetailsCard
                        data={project.project}
                        score={project.score || 0}
                      />
                    </div>
                  ))}
                </div>
              )}
              {showPagination && (
                <nav aria-label="Project pagination">
                  <div className="pagination-controls text-center my-4">
                    <button
                      onClick={() => paginate(currentPage - 1)}
                      disabled={currentPage === 1}
                      className="btn btn-secondary me-2"
                      aria-label="Previous page"
                    >
                      Prev
                    </button>
                    <span className="mx-2">
                      Page {currentPage} of {totalPages}
                    </span>
                    <button
                      onClick={() => paginate(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      className="btn btn-secondary ms-2"
                      aria-label="Next page"
                    >
                      Next
                    </button>
                  </div>
                </nav>
              )}
            </>
          ) : (
            !loading && !showDebounceMessage && searchQuery && (
              <div className="text-center my-5">
                <p className="text-muted">No projects found matching "{searchQuery}"</p>
                <button 
                  className="btn btn-link"
                  onClick={handleClearSearch}
                >
                  Clear search
                </button>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
}

export default Projects;
